module.exports = __webpack_public_path__ + "static/media/exclamation-triangle-solid.5593f6e1.svg";